import { Navigation, NavigationLink, NavigationPanel, NavigationPanelBody, NavigationPanelCloseButton, NavigationPanelHeader } from '@hub/navigation';
import React from 'react';
import { Text } from '@hub/text';
import { H3 } from '@hub/heading';
import useIsMounted from '../../../hooks/use-is-mounted';
import { useIsRouteChanging, useRouter } from '../../../next/router';
import { LOGOUT } from '../../../paths';
import { getAbsolutePathFromRouter } from '../../../helpers/url-helpers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const HeaderSecondaryMenu = _ref => {
  let {
    containerRef,
    isOpen,
    name,
    fadeDuration,
    onClose,
    onClickLink
  } = _ref;
  const router = useRouter();
  const isMounted = useIsMounted();
  const isRouteChanging = useIsRouteChanging();
  if (!isMounted) {
    return null;
  }
  const currentPath = getAbsolutePathFromRouter(router);
  const logoutUrl = getAbsolutePathFromRouter({
    route: LOGOUT,
    basePath: '/account',
    query: {
      path: currentPath === '' || currentPath.startsWith('/account') ? '/' : currentPath
    }
  });
  const accountMenuItem = {
    label: 'Account',
    url: '/account'
  };
  const logoutMenuItem = {
    label: 'Sign out',
    url: logoutUrl
  };
  const secondaryMenu = {
    title: 'Menu',
    items: [accountMenuItem, logoutMenuItem]
  };
  return /*#__PURE__*/_jsx(Navigation, {
    allowOpen: !isRouteChanging,
    containerRef: containerRef,
    placement: "right",
    onClose: onClose,
    trigger: "click",
    fadeDuration: fadeDuration,
    backgroundColor: "surfaceBrandPrimary",
    "data-id": "header-menus_secondary-menu_HeaderSecondaryMenu_Navigation",
    children: /*#__PURE__*/_jsxs(NavigationPanel, {
      isOpen: isOpen,
      "data-id": "header-menus_secondary-menu_HeaderSecondaryMenu_Navigation_NavigationPanel",
      children: [/*#__PURE__*/_jsx(NavigationPanelHeader, {
        "data-id": "header-menus_secondary-menu_HeaderSecondaryMenu_NavigationPanel_NavigationPanelHeader",
        children: /*#__PURE__*/_jsx(NavigationPanelCloseButton, {
          "data-id": "header-menus_secondary-menu_HeaderSecondaryMenu_NavigationPanelHeader_NavigationPanelCloseButton"
        })
      }), /*#__PURE__*/_jsxs(NavigationPanelBody, {
        "data-id": "header-menus_secondary-menu_HeaderSecondaryMenu_NavigationPanel_NavigationPanelBody",
        children: [name && /*#__PURE__*/_jsxs(H3, {
          as: Text,
          "data-id": "header-menus_secondary-menu_HeaderSecondaryMenu_H3",
          children: ["Hi, ", name, "!"]
        }), /*#__PURE__*/_jsx(NavigationLink, {
          href: accountMenuItem.url,
          onClick: event => onClickLink === null || onClickLink === void 0 ? void 0 : onClickLink(event, [secondaryMenu, accountMenuItem]),
          "data-id": "header-menus_secondary-menu_HeaderSecondaryMenu_NavigationPanelBody_NavigationLink",
          children: accountMenuItem.label
        }), /*#__PURE__*/_jsx(NavigationLink, {
          href: logoutMenuItem.url,
          onClick: event => onClickLink === null || onClickLink === void 0 ? void 0 : onClickLink(event, [secondaryMenu, logoutMenuItem]),
          "data-id": "header-menus_secondary-menu_HeaderSecondaryMenu_NavigationPanelBody_NavigationLink_7",
          children: logoutMenuItem.label
        })]
      })]
    })
  });
};